import logo from './logo.svg';
import './App.css';
import { useState } from 'react';
import Onboarding from './pages/Onboarding';
import Signin from './pages/Signin';
import ConsentformHE from './pages/ConsentformHE';
import Gallery from './pages/Gallery';
import ProgressBar from './components/ProgressBar';
import EnteryScreen from './pages/EnteryScreen';
import Questionnaire from './pages/Questionnaire';
import './components/i18n'
import axios from 'axios';
import {
  Navigate,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import ProtectedRoute from './Security/ProtectedRoute';
import { useAuth } from './Context/AuthProvider';
function App() {
  
  const { auth, logout, setAuth } = useAuth()

const enteryScreenLoader = async () => {
  try {
    const response = await axios.get('/dashboard/get_init_page');
    return response.data;
  } catch (error) {
    throw new Response("Error loading init data", { status: 500 });
  }
};

const consentformHELoader = async () => {
  try {
    const response = await axios.get('/dashboard/build_session');
    return response.data;
  } catch (error) {
    throw new Response("Error loading init data", { status: 500 });
  }
};
  //קוד בשביל הקרון:
  // var text ="Edit and save to reload. Edit and save to reload. Edit save to reload. Edit save to reload. Edit save to reload. Edit save to reload. Edit save to reload. Edit save to reload." 
  // const spamshow= text.length>100? true : false
  // const [show,setshow]=useState(false)

   {/* <div>

        
        <p className={`w-[250px]  ${spamshow&&show?"break-words line-clamp-2":""} `}>
          {text}
          
        </p>
        {spamshow&&<button className='bg-bubble-gum' onClick={()=>{setshow(!show)}}>{show?"המשך לקרוא":"סגור"}</button>}
        </div> */}
  

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Onboarding />,
      // errorElement: <ErrorPage/>,
      children: [
        // {
        //   path: "/Home",
        //   element: <Home/>,
        // },
        // {
        //   path: "dashboard",
        //   element: <Dashboard />,
        //   loader: ({ request }) =>
        //     fetch("/api/dashboard.json", {
        //       signal: request.signal,
        //     }),
        // },
        // {
        //   element: <AuthLayout />,
        //   children: [
        //     {
        //       path: "login",
        //       element: <Login />,
        //       loader: redirectIfUser,
        //     },
        //     {
        //       path: "logout",
        //       action: logoutUser,
        //     },
        //   ],
        // },
      ],
    },
    { 
      path: "Signin",
      element: <Signin />,
    },
    {
      path: "EnteryScreen",
      element:<ProtectedRoute isAuthenticated={auth}> <EnteryScreen /></ProtectedRoute>,
      loader: enteryScreenLoader,
    },
    {
      path: "Questionnaire/:sessionId",
      element: <ProtectedRoute isAuthenticated={auth}><Questionnaire /></ProtectedRoute>,
      
    },
    {
      path: "ProgressBar",
      element: <ProtectedRoute isAuthenticated={auth}><ProgressBar /></ProtectedRoute>
    },
    {
      path: "Gallery/:sessionId",
      element:<ProtectedRoute isAuthenticated={auth}> <Gallery /></ProtectedRoute>
    },
    {
      path: "ConsentformHE",
      element:<ProtectedRoute isAuthenticated={auth}> <ConsentformHE /></ProtectedRoute>,
      loader: consentformHELoader
    },
    {
      path: "*",
      element: <Navigate to="/Signin" />
    },
    

  ]);






  return (
    <div className="App">
      <header className="App-header font-heebo">
      <RouterProvider router={router} />
 
      </header>
    </div>
  );
}

export default App;
{/* <a
          className="App-link bg-MidBlue"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}